export default function distanceCalculator(nodeOne, nodeTwo) {
  return Math.sqrt(Math.pow(nodeOne.cx - nodeTwo.cx, 2) + Math.pow(nodeOne.cy - nodeTwo.cy, 2))
}